import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dimmer,
  Dropdown,
  Grid,
  Input,
  Loader,
  Segment,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { fetchM } from '../../actions/fetchM';

class UploadDocumentForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onChange: PropTypes.func,
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      uploads: [],
      tags: [],
      names: [],
      options: [],
      hasChanges: false,
    };
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  submit(url, opts = {}) {
    const { store } = this.context;
    return this.setLoading(true)
      .then(() => store.dispatch(fetchM(url, opts)))
      .then(res => res.json())
      .then(result => this.setLoading(false)
        .then(() => result))
      .catch(err => this.setLoading(false)
        .then(() => Promise.reject(err)));
  }
  handleSubmit = (event) => {
    event.preventDefault();
    if (this.state.uploads.length > 0) {
      const formData = new FormData(this.form);
      this.state.uploads.forEach((upload, idx) => {
        formData.append(`files_${idx}`, upload.file);
        formData.append(`tags_${idx}`, this.state.tags[idx]);
        formData.append(`names_${idx}`, this.state.names[idx]);
      });
      if (this.props.onSubmit) {
        this.props.onSubmit(event, formData);
      }
    }
  }
  handleCheckChanges() {
    if (!this.state.hasChanges) {
      this.setState({ hasChanges: true }, () => {
        if (this.props.onChange) {
          this.props.onChange(true);
        }
      });
    }
  }
  handleOnChange = () => {
    const files = Array.prototype.slice.call(this.uploadFiles.files);
    this.uploadFiles.value = null;
    if (window.FileReader) {
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const { uploads, tags, names } = this.state;
          const upload = {
            file,
            name: file.name.substring(0, file.name.length - 4),
            src: reader.result,
          };
          uploads.push(upload);
          tags.push([]);
          names.push(upload.name);
          this.setState({
            uploads,
            tags,
            names,
          }, () => {
            this.handleCheckChanges();
          });
        };
        reader.readAsDataURL(file);
      });
    }
  }
  handleRemove = (event, idx) => {
    event.preventDefault();
    const { uploads, tags, names } = this.state;
    uploads.splice(idx, 1);
    tags.splice(idx, 1);
    names.splice(idx, 1);
    this.setState({ uploads, tags, names });
  }
  handleAddFile = (event) => {
    event.preventDefault();
    this.uploadFiles.click();
  }
  handleTagsChange = (e, { value }, idx) => {
    const { tags } = this.state;
    tags[idx] = value;
    this.setState({ tags });
  }
  handleInputChange = (e, { value }, idx) => {
    const { names } = this.state;
    names[idx] = value;
    this.setState({ names });
  }
  handleAddition = (e, { value }) => {
    const { options } = this.state;
    if (options.some(o => o.value !== value)) {
      this.setState({
        options: [{ text: value, value }, ...options],
      });
    }
  }
  render() {
    return (
      <form
        encType="multipart/form-data"
        onSubmit={this.handleSubmit}
        name="uploadDocuments"
        ref={(ref) => { this.form = ref; }}
      >
        <input
          ref={(ref) => { this.uploadFiles = ref; }}
          type="file"
          onChange={this.handleOnChange}
          accept="application/pdf"
          multiple
          style={{ display: 'none' }}
        />
        <Grid verticalAlign="middle" stackable>
          <Grid.Row columns="equal">
            <Grid.Column only="computer" />
            <Grid.Column>
              <Grid verticalAlign="middle" columns="equal">
                <Grid.Column>
                  <Button
                    fluid
                    compact
                    primary
                    icon="add"
                    content="PDF"
                    onClick={this.handleAddFile}
                    disabled={this.state.loading}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Button
                    fluid
                    compact
                    type="submit"
                    positive
                    content={this.props.t('Upload', { ns: TRANSLATION_FILES.translation })} icon="cloud upload"
                    loading={this.state.loading}
                    disabled={this.state.uploads.length < 1 || this.state.loading}
                  />
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid stackable doubling columns={1}>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader inline="centered">{this.props.t('Uploading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          {
            this.state.uploads.length > 0 ?
              this.state.uploads.map((upload, idx) => (
                <Grid.Column key={idx}>
                  <Segment padded>
                    <Grid stackable columns="equal">
                      <Grid.Column>
                        <Input
                          placeholder={this.props.t('Name', { ns: TRANSLATION_FILES.translation })}
                          fluid
                          value={this.state.names[idx]}
                          disabled={this.state.loading}
                          onChange={(e, { value }) => this.handleInputChange(e, { value }, idx)}
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <Dropdown
                          options={this.state.options}
                          placeholder={this.props.t('Add tags', { ns: TRANSLATION_FILES.translation })}
                          search
                          noResultsMessage={this.props.t('Add tags', { ns: TRANSLATION_FILES.translation })}
                          selection
                          fluid
                          multiple
                          allowAdditions
                          value={this.state.tags[idx]}
                          onAddItem={this.handleAddition}
                          disabled={this.state.loading}
                          onChange={(e, { value }) => this.handleTagsChange(e, { value }, idx)}
                        />
                      </Grid.Column>
                      <Grid.Column width={2}>
                        <Button
                          type="button"
                          fluid
                          compact
                          icon="delete"
                          negative
                          disabled={this.state.loading}
                          onClick={e => this.handleRemove(e, idx)}
                        />
                      </Grid.Column>
                    </Grid>
                  </Segment>
                </Grid.Column>
              ))
            : null
          }
        </Grid>
      </form>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(UploadDocumentForm);



// WEBPACK FOOTER //
// ./src/containers/Documents/Form.jsx